import { render, staticRenderFns } from "./TempConfigCostItemModal.vue?vue&type=template&id=15f86e5d&scoped=true"
import script from "./TempConfigCostItemModal.vue?vue&type=script&lang=js"
export * from "./TempConfigCostItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f86e5d",
  null
  
)

export default component.exports